import classes from "./ChooseAdd.module.scss";
import { useSelector } from "react-redux";
import Spinner from "../../UI/Spinner";
import SelectRenewOrAdd from "./SelectRenewOrAdd/SelectRenewOrAdd";
import SelectAddType from "./CardAddBase/SelectAddType/SelectAddType";
import CardAddBase from "./CardAddBase/CardAddBase";
import SelectAddUsers from "./CardAddBase/SelectAddUsers/SelectAddUsers";
import SelectAddLang from "./CardAddBase/SelectAddLang/SelectAddLang";
import MyAddPurchase from "./MyAddPurchase/MyAddPurchase";
import RenewPlanCreditCard from "./CardAddBase/RenewPlanCreditCard/RenewPlanCreditCard";
import RenewPlanPix from "./CardAddBase/RenewPlanPix/RenewPlanPix";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

const ChooseAdd = ({ Products, PriceMonthly, PriceAnnual, PlanChosenId, changePropertyUrl }) => {
  const { t } = useTranslation();
  const payload = useSelector((state) => state.purchase);
  const { session } = useSelector((state) => state.session);

  const FlowAdd = {
    SelectRenewOrAdd: {
      component: (
        <SelectRenewOrAdd
          PlanItems={[
            t("purchase.at_afinando_you_can_boots_your_subscription"),
            t("purchase.purchase_packages_to_invite_more_users"),
            t("purchase.purchase_game_pack_in_other_languages"),
          ]}
          session={session}
        />
      ),
    },
    SelectAddType: {
      component: (
        <CardAddBase subtitle={ t("purchase.select_additional_package")}>
          <SelectAddType />
        </CardAddBase>
      ),
    },
    SelectAddUsers: {
      component: (
        <CardAddBase subtitle={ t("purchase.users_to_add")}>
          <SelectAddUsers session={session} Products={Products} />
        </CardAddBase>
      ),
    },
    SelectAddLang: {
      component: (
        <CardAddBase subtitle={ t("purchase.choose_language")}>
          <SelectAddLang session={session} Products={Products} />
        </CardAddBase>
      ),
    },
    RenewPlanCreditCard: {
      component: <RenewPlanCreditCard session={session} />,
    },
    RenewPlanPix: {
      component: <RenewPlanPix session={session} />,
    },
    MyAddPurchase: {
      component: (
        <MyAddPurchase
          PlanName={ t("purchase.professional")}
          PlanValueMonthly={PriceMonthly(PlanChosenId)}
          PlanValueAnnual={PriceAnnual(PlanChosenId)}
        />
      ),
    },
    OpenSpinner: { component: <Spinner /> },
  };
  const [CurrentFlow,SetCurrentFlow] = useState(null);
  useEffect(() => {
    if(payload?.purchase?.step){
      SetCurrentFlow(FlowAdd[payload.purchase.step]);
    }
  }, [payload]);

  return (
    <div className={classes.ChooseAddContent}>
      {(Products && CurrentFlow && CurrentFlow.component) ?? <Spinner />}
    </div>
  );
};
export default ChooseAdd;
